import * as React from 'react';
import { DashGrid, DashContent } from '../../components/UI/DashUI';
import TopBar from '../Site/TopBar';
import BotBar from '../Site/BotBar';
import { withThemer, ThemerProps } from '../../helpers/withThemer';
import { ThemeProvider } from 'styled-components';
import DashNav from '../Site/DashNav';

interface DashProps {
  children: React.ReactNode;
}

type Props = ThemerProps & DashProps;

const DashboardLayout: React.SFC<Props> = ({ children, theme, updateTheme }) => (
  <ThemeProvider theme={{ mode: theme }}>
    <DashGrid>
      <TopBar />
      <DashNav />
      <DashContent>{children}</DashContent>
      <BotBar theme={theme} updateTheme={updateTheme} />
    </DashGrid>
  </ThemeProvider>
);

export default withThemer(DashboardLayout);



// WEBPACK FOOTER //
// ./src/containers/Layouts/DashboardLayout.tsx